import { render, staticRenderFns } from "./CompanyScopeSelect.vue?vue&type=template&id=167d223c&scoped=true"
import script from "./CompanyScopeSelect.vue?vue&type=script&lang=ts"
export * from "./CompanyScopeSelect.vue?vue&type=script&lang=ts"
import style0 from "./CompanyScopeSelect.vue?vue&type=style&index=0&id=167d223c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d223c",
  null
  
)

export default component.exports